export const lightBgn = "rgb(247, 247, 247)";
export const darkBgn = " rgb(26, 24, 27)";
export const accentColor = "rgb(173, 7, 96)";
